import React from 'react';
import { Card, CardTitle } from 'material-ui/Card';
import { List, ListItem } from 'material-ui/List';
import CustomerIcon from 'material-ui/svg-icons/toggle/star';
import { translate } from 'admin-on-rest';

import StarRatingField from '../review/StarRatingField';

const styles = {
    card: { borderLeft: 'solid 4px #fd9512', flex: 1, marginLeft: '1em' },
    icon: { float: 'right', width: 50, height: 50, padding: 16, color: '#fd9512'},
	review: { fontSize: 17, display: 'block', fontStyle: 'italic', marginTop : '12px', marginBottom: '10px' },
	heading: { fontSize: 17 },
	date: { opacity: '0.6' }
};

export default translate(({ reviews = [], nb, translate }) => (
    <Card style={styles.card}>
        <CustomerIcon style={styles.icon} />
        <CardTitle title={nb} />
        <List>
		    {reviews.map(record =>
                <ListItem href={`#`} key={record.id}>
                	<span style={styles.heading}><strong>{record.subject}</strong> <StarRatingField rating={record.rating} /></span>
					<br/>
					<span style={styles.review}>{record.review}</span>					
					<small style={styles.date}>{record.site_source} - {new Date(record.created_at).toLocaleDateString()}</small>
                </ListItem>
            )}
        </List>
    </Card>
));



// WEBPACK FOOTER //
// ./src/dashboard/ReviewsList.js